import React from 'react';
import SvgIcon from './SvgIcon';

const Label = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M9.6 22.875L1.125 14.4 14.4 1.125l7.95.525.525 7.95L9.6 22.875z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18 7.125a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM9.6 10.125l2.138 2.137m0-4.237l4.237 4.237-4.237-4.237zM7.5 12.262l3.188 3.188L7.5 12.262z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

Label.displayName = 'LabelIcon';

export default Label;
